import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import { Button, ButtonModify, ButtonProceed } from '../../components/buttons';
import { Layout, MinMaxLayout, SeventyThirtyLayout, SixtyFourtyLayout } from '../../layouts';
import Welcome from '../../layouts/welcome';
import Row from '../../components/row';
import Container from '../../layouts/containers/container';
import ActivityItemNew from '../../components/activity/activity-item-new';
import List from '../../components/list';
import InputsDropdown from '../../components/inputs/inputs-dropdown';
import SearchBar from '../../components/searchbar';
import ContainerTable from '../../layouts/containers/container-table';
import { getDSTLocalTime, stringToFriendlyDatetime } from '../../lib/helpers/datetime-helpers';
import ContainerIndex from '../../layouts/containers/container-index';
import IndexCard from '../../components/cards/index-card';
import { SmallPill} from '../../components/pills';
import eventsApi from '../../lib/events/events-api';
import { BsArrowReturnLeft } from 'react-icons/bs';
import MediaHelper from '../../lib/helpers/media';
import RenderThisIf from '../../components/renderIf';
import EmptyState from '../../components/states/empty';
import auth from '../../lib/users/auth';
import { COMPANY_BOOK_EVENTS } from '../../utils/permissions';

class EventsIndex extends Component {
    constructor(props) {
        super(props);

        this.state = {
            events: null,
            eventTypes: [],
            eventTypeIds: [],
            page: 1,
            per_page: 8,
            from: null,
            search: '',
        }
    }

    componentDidMount() {
        this.fetchEvents();
        this.fetchEventTypes();
    }   

    fetchEvents() {
        this.setState({ events: null });
        
        let params = {
            page: this.state.page,
            per_page: this.state.per_page,
            from: this.state.from,
            from: new Date(),
            term: this.state.search
        }

        if (this.state.eventTypeIds?.length > 0) {
            params.event_type_ids = this.state.eventTypeIds;
        }

        if (this.state.search?.length !== 0) {
            return eventsApi.search(params).then(({ data, meta }) => {
                this.setState({ events: data, meta })
            })
        }

        eventsApi.getEvents(params).then(({ data, meta }) => {
            this.setState({ events: data, meta })
        });
    }

    fetchEventTypes() {
        eventsApi.getEventTypes().then(({ data }) => {
            this.setState({ eventTypes: data });
        });
    }

    onNext() {
        this.setState({ page: this.state.page + 1 }, this.fetchEvents.bind(this));
    }

    onPrevious() {
        this.setState({ page: this.state.page - 1 }, this.fetchEvents.bind(this));
    }

    addEventType({ value }) {
        const eventTypeIds = Array.isArray(this.state.eventTypeIds) ? [ ...this.state.eventTypeIds ] : []

        if (eventTypeIds.includes(value)) return;

        eventTypeIds.push(value);

        this.setState({ eventTypeIds }, () => this.fetchEvents());
    }

    deleteEventType(id) {
        let eventTypeIds = Array.isArray(this.state.eventTypeIds) ? [ ...this.state.eventTypeIds ] : []

        eventTypeIds = eventTypeIds.filter((val) => val !== id);

        this.setState({ eventTypeIds }, () => this.fetchEvents());
    }

    render() {
        return <ContainerIndex>
            <ContainerIndex.Filters>
                <List gap="20px" style={{ width: '100%' }}>
                    <SearchBar
                        value={this.state.search}
                        search={false}
                        onChange={(e) => {
                            this.setState({ search: e?.target?.value }, () => this.fetchEvents())
                        }}
                    />
                    <Row gap="20px" wrap>
                        <InputsDropdown
                            label="Event Types"
                            items={
                                this.state.eventTypes?.map((type) => {
                                    return {
                                        label: type?.name,
                                        value: type?.id
                                    }
                                })
                            }
                            onChange={this.addEventType.bind(this)}
                        />
                    </Row>
                </List>
                <Row gap="10px" wrap>
                    { this.state.eventTypeIds?.map((type, index) => {
                        const eventType = this.state.eventTypes.find(t => t.id === type);

                        return <SmallPill key={index} removable={true} onRemoveClick={() => this.deleteEventType(type)}>{ eventType?.name }</SmallPill>
                    }) }
                </Row>
            </ContainerIndex.Filters>

            <RenderThisIf
                renderIf={this.state?.events === null || this.state.events?.length === 0}
                render={
                    <EmptyState 
                        loading={this.state.events === null} 
                        title="Events"
                        description="There seems to be nothing here" 
                        style={{ minHeight: '300px' }}
                    />
                }
            >
                <ContainerIndex.Content>
                    { this.state.events?.map((event) => {
                        return (
                            <IndexCard
                                image={MediaHelper.formatPublicPath(`/images/${event?.content?.feature_image?.[0]?.file_name}`)}
                                title={event?.name}
                                subtitle={event?.description}
                                infos={[
                                    {
                                        label : 'DATE',
                                        value : getDSTLocalTime(event?.start).format('DD/MM/YYYY')
                                    },
                                    {
                                        label : 'TIME',
                                        value : getDSTLocalTime(event?.start).format('HH:mm')
                                    }
                                ]}
                                buttons={
                                    <>
                                        <ButtonProceed onClick={() => window.location.href = `/mydmc/events/${event.id}`}>View</ButtonProceed>
                                        { (auth.hasPermission(COMPANY_BOOK_EVENTS) || auth.isOwnerOrManager()) && <ButtonModify onClick={() => window.location.href = `/mydmc/events/${event.id}/book`}>Book</ButtonModify> }
                                    </>
                                }
                            />
                        )
                    }) }
                </ContainerIndex.Content>
            </RenderThisIf>

            <ContainerIndex.Pagination
                currentPage={this.state.page}
                maxPages={this.state.meta?.last_page}
                onNext={this.onNext.bind(this)}
                onPrevious={this.onPrevious.bind(this)}
            />
        </ContainerIndex>
    }
}

const el = document.getElementById('events-index');

if (el) {
    ReactDOM.render(
        <Layout 
            theme="dark"
            topLeft={<Welcome seam title="Welcome to your" subtitle="Events"/>}
            topRight={
                <Row gap="20px">
                    {/* <Button className="button--view">Book Co-Working</Button> */}
                </Row>
            }
        >
            <MinMaxLayout
                main={<EventsIndex/>}
            />
        </Layout>    
    , el);
}
